var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.99995 1.45703C10.0629 1.45703 12.5458 3.93991 12.5458 7.00289C12.5458 10.0659 10.0629 12.5487 6.99995 12.5487C3.93697 12.5487 1.4541 10.0659 1.4541 7.00289C1.4541 3.93991 3.93697 1.45703 6.99995 1.45703Z",
    fill: "#DB0632"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.99999 13.2552C3.54253 13.2552 0.744738 10.4442 0.744738 7.00331C0.744738 3.56243 3.55579 0.748061 6.99999 0.748061C10.4442 0.748061 13.2519 3.55911 13.2519 7.00331C13.2519 10.4475 10.4541 13.2552 6.99999 13.2552ZM6.99999 0.277344C3.28728 0.277344 0.277344 3.2906 0.277344 7C0.277344 10.7094 3.29059 13.7226 6.99999 13.7226C10.7094 13.7226 13.7226 10.7094 13.7226 7C13.7226 3.2906 10.7094 0.277344 6.99999 0.277344Z",
    fill: "#132122"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedIndicator);
export default __webpack_public_path__ + "static/media/redIndicator.80d8c1f8.svg";
export { ForwardRef as ReactComponent };